
export default {
    functional: true,
    render: function render(h, _ref) {
        var children = _ref.children;

        return h(
            "v-flex",
            { "class": "fill-height panel-box col xs12" },
            [h(
                "v-card",
                { "class": "elevation-0 fill-height wrap" },
                [h(
                    "v-container",
                    {
                        attrs: { fluid: true },
                        "class": "fill-height padding style-padding" },
                    [h(
                        "v-layout",
                        {
                            attrs: { row: true, wrap: true }
                        },
                        [children]
                    )]
                )]
            )]
        );
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/shared/panel-box.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/shared/panel-box.vue
// module chunks = 34